import * as React from 'react';
import type { UpdatePrioritizedProductPayload } from 'contracts/prioritized-products';
import { api } from 'services/api';

type UpdatePrioritizedProductParams = {
  productId: number;
  payload: UpdatePrioritizedProductPayload;
}

export const useUpdatePrioritizedProduct = () => {
  const updatePrioritizedProduct = React.useCallback(async (params: UpdatePrioritizedProductParams) => {
    await api.put(`/inventory/prioritized-products/${params.productId}`, params.payload);
  }, []);

  return {
    updatePrioritizedProduct,
  };
};